<template>
  <div v-if="mode" class="text-left">
    <comment :element-uuid="element.uuid" :submission-uuid="main_sid" />
    <p>{{ saveData.link_desc | token_replace(nid)}}</p>
    <p>
      <a :href="saveData.link">Click to this link to read the article</a>
    </p>
    <p>Confirm that you have read the article:</p>
    <md-field class="label-top">
      <md-checkbox @change="updateValue" v-model="readed">Yes, I have read the article.</md-checkbox>
    </md-field>
    <p>{{ saveData.helper_text | token_replace(nid)}}</p>
    <md-field :class="messageClass">
      <label>{{saveData.label | token_replace(nid)}}</label>
      <md-textarea
        :maxlength="saveData.counter"
        v-model="saveData.value"
        :md-counter="saveData.counter"
        :required="saveData.required === true ? 'required' : null"
      ></md-textarea>
      <span class="md-error">*Required.</span>
    </md-field>
  </div>
  <md-card v-else class="md-elevation-2 md-layout-item">
    <fb-controll
      :controll="saveData.label || 'Text'"
      @setting-click="showSettings"
      @collapse-click="collapsePreview"
      @menu-delete="$emit('menu-delete')"
    />
    <md-content v-show="!collapse" class="text-left">
      <p>{{ saveData.link_desc | token_replace(nid)}}</p>
      <p>
        <a :href="saveData.link">Click to this link to read the article</a>
      </p>
      <p>Confirm that you have read the article:</p>
      <md-field class="label-top">
        <md-checkbox v-model="readed">Yes, I have read the article.</md-checkbox>
      </md-field>
      <p>{{ saveData.helper_text | token_replace(nid)}}</p>
      <md-field :class="messageClass">
        <label>{{saveData.label | token_replace(nid)}}</label>
        <md-textarea
          :maxlength="saveData.counter"
          v-model="saveData.value"
          :md-counter="saveData.counter"
          :required="saveData.required === true ? 'required' : null"
        ></md-textarea>
        <span class="md-error">*Required.</span>
      </md-field>
    </md-content>
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>Settings</md-dialog-title>
      <md-dialog-content>
        <md-field>
          <label>Link</label>
          <md-input v-model="tempData.link"></md-input>
        </md-field>
        <md-field>
          <label>Link Description</label>
          <md-input v-model="tempData.link_desc"></md-input>
        </md-field>
        <md-field>
          <label>Helper text</label>
          <md-input v-model="tempData.helper_text"></md-input>
        </md-field>
        <md-field>
          <label>Label</label>
          <md-input v-model="tempData.label"></md-input>
        </md-field>
        <md-field>
          <label>Value</label>
          <md-input v-model="tempData.value"></md-input>
        </md-field>
        <md-field>
          <label>Counter</label>
          <md-input v-model="tempData.counter"></md-input>
        </md-field>
        <md-checkbox v-model="tempData.required">Required</md-checkbox>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="cancel">Close</md-button>
        <md-button class="md-primary" @click="save">Save</md-button>
      </md-dialog-actions>
    </md-dialog>
  </md-card>
</template>

<script>
import FbElementMixin from "./FbElementMixin";

export default {
  name: "FbExternalLink",
  props: ["element", "mode", "validate"],
  mixins: [FbElementMixin],
  created() {
    if (
      this.sid &&
      this.sid != "" &&
      window.drupalSettings.form_builder[this.nid]["submissions"][this.sid][
        this.element.uuid
      ]
    ) {
      this.saveData.value =
        window.drupalSettings.form_builder[this.nid]["submissions"][this.sid][
          this.element.uuid
        ].value.value;
      this.readed =
        window.drupalSettings.form_builder[this.nid]["submissions"][this.sid][
          this.element.uuid
        ].value.readed;
      this.$emit("set-value", this.value);
    }
    this.$emit("validation", this.valid);
  },
  computed: {
    messageClass() {
      return {
        "md-invalid": !this.valid && this.validate === true
      };
    },
    valid() {
      if (this.isDraft) {
        return true;
      }
      let val;
      val = !(this.saveData.required === true &&
              this.saveData.value == "" &&
              this.readed == false);
      return val;
    },
    value() {
      if (this.valid) {
        return {
          uuid: this.element.uuid,
          label: this.saveData.label,
          value: {
            link: this.saveData.link,
            readed: this.readed,
            value: this.saveData.value
          },
          type: this.element.type
        };
      }
      return undefined;
    }
  },
  data() {
    return {
      readed: false,
      tempData: {
        label: this.element.data.label || "",
        value: this.element.data.value || "",
        link: this.element.data.link || "",
        link_desc: this.element.data.link_desc || "",
        helper_text: this.element.data.helper_text || "",
        counter: this.element.data.counter || "500",
        required: this.element.data.required || ""
      },
      saveData: {
        label: this.element.data.label || "",
        value: this.element.data.value || "",
        link: this.element.data.link || "",
        link_desc: this.element.data.link_desc || "",
        helper_text: this.element.data.helper_text || "",
        counter: this.element.data.counter || "500",
        required: this.element.data.required || ""
      }
    };
  },
  methods: {
    updateValue(val) {
      this.$emit("set-value", this.value);
      this.$emit("validation", this.valid);
    }
  },
  watch: {
    "saveData.value": function value() {
      this.$emit("validation", this.valid);
      this.$emit("set-value", this.value);
    }
  }
};
</script>
